<div class="nav-bar">
    <div style="display: flex;">
        <div class="img"></div>
        <div class="nav-button-group">
            <button mat-button routerLink="cv-detail/de" [ngClass]="{'link-active': isCvDetailRoute}">
                <mat-icon svgIcon="account_box" style="color: blue;"></mat-icon>
                Mein Profil
            </button>
            <button mat-button routerLink="cv-list" routerLinkActive="link-active">
                <mat-icon svgIcon="clinical_notes"></mat-icon>
                Berater CVs
            </button>
            <button *ngIf="showSearch" mat-button routerLink="search" routerLinkActive="link-active">
                <mat-icon svgIcon="person_search"></mat-icon>
                Suchfunktion
            </button>
        </div>
    </div>
    <div class="logout-block">
        <div class="profile">
            <div *ngIf="user" class="initials">
                <span>{{user.substring(0, 1).toUpperCase()}}</span>
            </div>
            <div class="user-info">
                <span *ngIf="user" class="fullname">{{user}}</span>
                <span class="email">{{email}}</span>
            </div>
        </div>
        <button mat-icon-button (click)="logout()">
            <mat-icon svgIcon="logout"></mat-icon>
        </button>
    </div>
</div>
